var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.approvalFlow.detalle &&
    _vm.approvalFlow.detalle.pasos &&
    _vm.flow.numero
    ? _c(
        "b-card",
        { staticClass: "card-transaction", attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c("b-card-title", [
                _vm._v(
                  " Detalles del flujo #" + _vm._s(_vm.flow.numero) + " - "
                ),
                _vm.flow.nombreAprobacion
                  ? _c("span", [_vm._v(_vm._s(_vm.flow.nombreAprobacion))])
                  : _c("span", [_vm._v(_vm._s(_vm.flow.nomnbreEjecucion))])
              ])
            ],
            1
          ),
          _c(
            "b-card-body",
            _vm._l(_vm.approvalFlow.detalle.pasos, function(step) {
              return _c(
                "div",
                { key: step.id, staticClass: "transaction-item" },
                [
                  _c(
                    "b-media",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-media-aside",
                        [
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.PROCESSING
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Procesando",
                                      expression: "'Procesando'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-warning"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "LoaderIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.PENDING
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Pendiente",
                                      expression: "'Pendiente'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-secondary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "AlertCircleIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.APPROVED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Aprobado",
                                      expression: "'Aprobado'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-success"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "ThumbsUpIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.REJECTED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Rechazado",
                                      expression: "'Rechazado'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-danger"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "ThumbsDownIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.FORWARDED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Reenviado",
                                      expression: "'Reenviado'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-info"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { size: "18", icon: "ShuffleIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          step.aprobacionesPasoEstadoId ===
                          _vm.flowStates.RETURNED
                            ? _c(
                                "b-avatar",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Devuelto",
                                      expression: "'Devuelto'"
                                    }
                                  ],
                                  attrs: {
                                    rounded: "",
                                    size: "28",
                                    variant: "light-info"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      size: "18",
                                      icon: "CornerUpLeftIcon"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("b-media-body", [
                        _c(
                          "h6",
                          { staticClass: "transaction-title" },
                          [
                            _vm._v(" " + _vm._s(step.paso.responsable) + " "),
                            step.id ===
                            _vm.approvalFlow.detalle.ejecucion.pasoActualId
                              ? _c("feather-icon", {
                                  attrs: {
                                    size: "10",
                                    variant: "warning",
                                    icon: "StarIcon"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("small", [
                          _vm._v(
                            _vm._s(_vm._f("dateFormat")(step.fechaInicioPaso))
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticClass: "font-small-2 text-success" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("timeApprovals")(step.minutosEnPaso)) +
                        " "
                    )
                  ])
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }